import type { ReactNode } from "react";
import { RemixIcon, type RemixIconSize } from "./RemixIcon/RemixIcon";
import { getAccentPillColor } from "../../lib/accentPalette";

interface Props {
    icon: string | null | undefined;
    label: string;
    iconSize?: RemixIconSize;
    wrapperClassName?: string;
    labelClassName?: string;
    interactive?: boolean;
    suffix?: ReactNode;
}

export function GLAWithIcon({
    icon,
    label,
    iconSize = "md",
    wrapperClassName,
    labelClassName,
    interactive,
    suffix,
}: Props) {
    return (
        <div
            className={`group flex min-w-0 items-center gap-2 ${interactive ? "cursor-pointer" : ""} ${wrapperClassName ?? ""}`}
        >
            <RemixIcon icon={icon} size={iconSize} pillColor={getAccentPillColor(icon)} />
            <span className={`min-w-0 truncate leading-tight ${labelClassName ?? ""}`}>
                {label}
                {suffix}
            </span>
        </div>
    );
}
